<template>
    <div :class="classes" @click="this.emitValue">
        <i v-if="this.isSelected" class="fa-sharp fa-solid fa-arrow-right"></i>
        <span class="select-button__content">
        <slot></slot>
        </span>
        <i v-if="this.isSelected" class="fa-sharp fa-solid fa-arrow-left"></i>
    </div>
</template>

<script>
export default {
    name: 'SelectButton',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number, Boolean],
            required: false,
            default: null
        },
        value: {
            type: [String, Number, Boolean],
            required: true
        },
        cssClasses: {
            type: Array,
            required: false,
            default: []
        }
    },
    computed: {
        isSelected(){
            return this.modelValue === this.value
        },
        classes(){
            let classes = ['select-button', ...this.cssClasses]
            if (this.isSelected){
                classes.push('select-button--selected')
            }
            return classes
        }
    },
    methods: {
        emitValue(){
            this.$emit('update:modelValue', this.value)
        }
    }
}

</script>